<div class="dialog-container text-align-center">
  <div mat-dialog-content>
    <img
      src="../../../assets/Icons/transfer-error-icon-200x200.png"
      alt="Orange Exclamation Mark Image"
      width="100"
      height="100"
      class="error-image"
    />
    <h3 *ifPermissions="['API View', 'Mobile Cred View']">
      This branch is either not configured or has no active credentials for the
      selected product.
    </h3>
    <h3 *ifPermissions="['API Support', 'Engage Support', 'EB Support']">
      This customer has been configured for the selected product(s) but has NOT
      yet issued any credentials/licenses.
    </h3>
    <br />
    <h3 *ifPermissions="['API View', 'Mobile Cred View']">
      Please try another branch or contact support at
      <a href="mailto:mobilecredentials@allegion.com"
        >mobilecredentials&#64;allegion.com</a
      >.
    </h3>
  </div>
  <div mat-dialog-actions class="align-right">
    <button mat-button [mat-dialog-close]="true">OK</button>
  </div>
</div>
